import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { Configuration } from '../../common-api//configuration';
import { ApiModule as SystemParameterApiModule } from '../../common-api/rt-common-api/system-parameter';
import { EnvConfig } from '../../common/public-api';
import {
  CacheService,
  MEMORY_CACHE_SERVICE,
} from '../../common/services/cache.service';
import { LocalStorageService } from '../../common/services/local-storage.service';
@NgModule({
  declarations: [],
  imports: [SystemParameterApiModule],
  providers: [
    {
      provide: MEMORY_CACHE_SERVICE,
      useFactory: cacheServiceFactory,
      deps: [LocalStorageService],
    },
  ],
})
export class CoreFeatureFlagModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreFeatureFlagModule) {
    if (parentModule) {
      throw new Error(
        `${
          new.target.name
        } is already loaded. Import in your base AppModule only.`
      );
    }
  }

  static forRoot(
    config: EnvConfig
  ): ModuleWithProviders<CoreFeatureFlagModule> {
    return {
      ngModule: CoreFeatureFlagModule,
      providers: [
        ...(SystemParameterApiModule.forRoot(() =>
          configurationFactory(config.apiUrls?.['retailSystemParameter'])
        ).providers ?? []),
      ],
    };
  }
}
function cacheServiceFactory(
  locaStorageService: LocalStorageService
): CacheService {
  var cacheDuration = 5; // 5 分鐘
  return new CacheService(locaStorageService, cacheDuration);
}
function configurationFactory(url?: string): Configuration {
  return new Configuration({
    basePath: url ?? undefined,
  });
}
